<!-- H5关联文件 -->
<template lang="pug">
van-popup(v-model="visible", position="bottom", closeable, :overlay="false", @closed="$destroy()")
  .associateFile
    .titleRow 关联文件
    .content
      template(v-if="!keyword")
        //- 面包屑
        ul.breadcrumb
          li(v-for="vo in navList", :key="vo.folderId", @click="intoFolder(vo)") {{ vo.folderName }}
        //- 文档列表
        van-pull-refresh.folderList(v-model="refreshing", @refresh="onRefresh")
          .folderItem(v-for="vo in docList", :key="vo.folderId", :class="{ active: checkFileMap[vo.folderId] }", @click="intoFolder(vo)")
            .folder_left
              FileIcon(:row="vo", :icon-size="32", readonly, @click.native.stop="toggleFolder(vo)")
            .folder_right
              FileName(:name="vo.folderName")
              .date {{ vo.checkInDate || vo.operDate }}
          .empty(v-if="!docList.length") 暂无数据
    van-row.buttons(gutter="16")
      van-col.footer-slot(v-if="customSlots.footer", span="24")
        component(:is="customSlots.footer")
      van-col(span="6")
        van-button(type="info", size="normal", plain, @click="openCheckList") 列表({{ checkList.length }})
      van-col(span="6", offset="6")
        van-button(type="info", size="normal", plain, @click="visible = false") 取消
      van-col(span="6")
        van-button(type="info", size="normal", @click="confirm") 确定
  van-popup.list-popup(v-model="popupVisible", closeable, position="bottom")
    van-checkbox-group.popup-list(v-model="popupChecks", ref="checkboxGroup")
      label.cell(v-for="vo in checkList", :key="vo.folderId")
        input(type="checkbox", v-model="popupChecks", :value="vo.folderId")
        .cell-title
          FileIcon(:row="vo", :icon-size="24", readonly)
          FileName(:name="vo.folderName")
        .cell-right
          van-checkbox(:name="vo.folderId")
    .popup-bottom
      .popup-bottom-left
        van-button(@click="checkAll(true)") 全选
        van-button(@click="checkAll()") 全不选
      .popup-bottom-right
        van-button(type="danger", @click="popupDel") 批量删除
</template>

<script>
import Search from "@/CommonDP/pages/appView/components/associateFile/search.vue";
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import BasicDoc from "@/CommonDP/components/custom-dialog/Doc.vue";
import docService from "@/CommonDP/service/doc-service";
import isObject from "lodash/isObject";
import FileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
import FileName from "@/CommonDP/components/FileList/fileName.vue";
const cacheMap = new Map();
const parentMap = new Map();
export default {
  components: { Search, FileIcon, FileName },
  extends: BasicDoc,
  mixins: [asyncMixin],
  props: {
    queryFolder: {
      type: Function,
      async default(vo) {
        const params = {
          folderId: vo.folderId,
          isRead: vo.isRead,
          priviAll: vo.priviAll,
          noRightClickMenu: true,
          prjId: this.prjId
        };
        const { data } = await docService.queryTree(params);
        return data.map(item => {
          const { childFolder = 0 } = item;
          return {
            ...item,
            leaf: childFolder === 0
          };
        });
      }
    }
  },
  data() {
    return {
      visible: true,
      checkList: [],
      popupChecks: [],
      folderId: "",
      // --
      refreshing: false,
      keyword: "", // 搜索关键字
      docList: [],
      popupVisible: false
    };
  },
  computed: {
    currentFolder() {
      return cacheMap.get(this.folderId);
    },
    navList() {
      let vo = this.currentFolder;
      const list = [];
      while (vo) {
        list.push(vo);
        vo = parentMap.get(vo.folderId);
      }
      list.push({ folderName: "根目录", folderId: "" });
      return list.reverse();
    },
    loading() {
      return this.refreshing;
    },
    checkFileMap() {
      const obj = {};
      for (const { folderId } of this.checkList) {
        obj[folderId] = !!folderId;
      }
      return obj;
    }
  },
  created() {
    cacheMap.clear();
    parentMap.clear();
    this.checkList = [...this.defaultList];
    this.intoFolder(this.folderId);
  },
  methods: {
    async popupDel() {
      await this.$dialog.confirm({
        title: "警告",
        message: "确定批量移除文件"
      });
      const { checkList, popupChecks } = this;
      const delSet = new Set(popupChecks);
      this.checkList = checkList.filter(({ folderId }) => !delSet.has(folderId));
    },
    checkAll(tag) {
      this.$refs.checkboxGroup.toggleAll(tag);
    },
    openCheckList() {
      this.popupVisible = true;
      this.popupChecks = [];
    },
    parseVo(vo, parent) {
      const { check } = this;
      vo.$check = check.call(this, vo);
      vo.$icon = tableRowIcon(vo);
      cacheMap.set(vo.folderId, vo);
      parentMap.set(vo.folderId, parent);
    },
    async onRefresh() {
      this.intoFolder(this.folderId).finally(() => {
        this.refreshing = false;
      });
    },
    async intoFolder(folder) {
      let folderId;
      if (isObject(folder)) {
        const isFile = folder.isFolder === 0;
        if (isFile) return this.toggleFolder(folder);
        folderId = folder?.folderId;
      } else {
        folderId = folder;
      }
      this.docList = await this.getDocList(folderId);
      this.folderId = folderId;
    },
    toggleFolder(vo) {
      console.log(vo);
      if (!vo.$check) return;
      const index = this.checkList.findIndex(({ folderId }) => vo.folderId === folderId);
      if (index === -1) {
        this.addFolder(vo);
      } else {
        this.checkList.splice(index, 1);
      }
    },
    addFolder(vo) {
      const checkList = this.multiple ? this.checkList : [];
      const bothList = [...this.navList, vo];
      checkList.push({
        ...vo,
        fullName: bothList.map(({ folderName }) => folderName).join("/"),
        fullIdPath: bothList.map(({ folderId }) => folderId).join("/")
      });
      this.checkList = checkList;
    },
    async getDocList(folderId) {
      const item = cacheMap.get(folderId);
      const isRoot = !item;
      const query = isRoot ? this.queryRoot : this.queryFolder;
      const pid = folderId || "0";
      let childList = [];
      try {
        // 获取数据
        if (pid !== "recycle") {
          const list = await query.call(this, item);
          const { filter } = this;
          childList = list.map((vo) => this.parseVo(vo, item) || vo).filter((vo) => filter.call(this, vo));
          // 添加子元素
          // if (isRoot) {
          //   // 根目录时 自动访问第一个文件夹
          //   const next = childList[0];
          //   next && this.intoFolder(next);
          // }
        }
      } catch (error) {
        return [];
      }
      return childList;
    }
  }
};
</script>

<style lang="scss" scoped src="./associate.scss">
</style>
